import { Button, ButtonProps } from '@mantine/core';
import { MouseEventHandler, ReactNode } from 'react';

interface PrimaryButtonProps extends ButtonProps {
  children: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
}

export function PrimaryButton({ children, ...rest }: PrimaryButtonProps) {
  return (
    <Button size="md" variant="filled" {...rest}>
      {children}
    </Button>
  );
}
